<h1 class="mb-2">Donor Call Sheet: <span class="inline-block mx-2 red-60">February Pledge</span> <span class="inline-block mx-2 font-light">2/21/2025</span></h1>

<div class="grid">
    <div class="col-12 sm:col-6 flex align-items-center">
        <h2 class="mb-0">Assigned to Tiffany Grace | Not Started</h2>
    </div>
    <div class="col-12 sm:col-6 flex align-items-center sm:justify-content-end pb-4">
        <rc-generic-button 
            label="Edit Sheet Info"
            id="button-edit"
            level="secondary"
            borderStyle="outline"
            [classes]="['mr-1 my-1']" />
        <p-button 
            label="Export" 
            icon="fa-sharp fa-light fa-download" 
            id="button-export" 
            severity="secondary"
            styleClass="my-1" 
            class="ml-0"
            data-cy="btn-export"></p-button>
    </div>
</div>



<div class="card flex justify-content-center">
    <p-accordion [activeIndex]="0" styleClass="dcs-accordion">
        <p-accordionTab header="Amy Elsner">
            <ng-template pTemplate="header">
                <span class="btn-complete-wrapper">
                    <button class="btn-complete" (click)="completeSheetToggle($event)">
                        Complete
                    </button>
                </span>
            </ng-template>

            <div class="grid">
                <div class="col-12 md:col-6 dcs-donor-info py-4 pr-4">
                    <div class="mb-3">
                        <span class="donor-id inline-block mb-2"><a href="#">6592726654</a></span> 
                        <span class="inline-block mb-2">
                            <span class="donor-occupation">Attorney</span> 
                            <span class="donor-employer">Wharton law PLLC</span>
                        </span>
                    </div>
                    <div class="donor-contact-info mb-4 gap-1">
                            <span><b class="inline-block mr-2">Home:</b> <a href="#">(987)890-7890</a></span>
                            <span><b class="inline-block mr-2">Mobile:</b> <a href="#">(987)890-7890</a></span>
                            <span><b class="inline-block mr-2">Office:</b> <a href="#">(987)890-7890</a></span>
                            <span><b class="inline-block mr-2">Email:</b> <a href="#">amy.elsner&#64;whartonlaw.com</a></span>
                    </div>
                    <div class="donor-suppressions mb-4 flex flex-wrap gap-1">
                        <p-tag value="Do Not Solicit" [rounded]="true" severity="warning" />
                        <p-tag value="Do Not Email" [rounded]="true" severity="warning" />
                        <p-tag value="Do Not Call" [rounded]="true" severity="warning" />
                    </div>
                    <div class="donor-biography mb-4">
                        <b class="inline-block mr-2">Biography:</b>
                        <span> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</span>
                    </div>
                    <rc-generic-button 
                        label="Update"
                        id="button-add-donor"
                        borderStyle="outline"
                        size="small"
                        level="secondary"
                        (click)="showDialog = true" />
                </div>

                <div class="col-12 md:col-6 dcs-call-actions py-4 pl-4">
                    <div class="formgrid grid">
                        <div class="col-12 sm:col-6 my-3">
                            <div class="mb-3 field">
                                <label class="field-label">
                                    Donor Contact
                                </label>
                                <p-checkbox
                                    inputId="callInitiated"
                                    label="Call Initiated" />
                            </div>
                            <div>
                                <p-checkbox
                                    inputId="emailSent"
                                    label="Email Sent" />
                            </div>
                        </div>
                        <div class="col-12 sm:col-6 my-3">
                            <div class="mb-3 field">
                                <label class="field-label">Last Call Date</label>
                                <p-calendar id="callDate" formControlName="callDate" [showIcon]="true" [iconDisplay]="'input'" placeholder="MM/DD/YYYY">
                                </p-calendar>
                            </div>
                            
                            <div>
                                <p-toggleButton name="isPrimary" onLabel="Answered" offLabel="Not Answered" onIcon="pi pi-check-circle" offIcon="pi pi-ban" formControlName="answered" />
                            </div>
                        </div>
                        
                        <div class="col-12 field mb-3">
                            <label class="field-label">
                                Call Note
                            </label>
                            <textarea rows="4" pInputTextarea ></textarea>
                        </div>
                        <div class="col-12 mb-3">
                            <rc-generic-button 
                                label="Save Info"
                                id="save-call-info"
                                size="small" />
                        </div>

                    </div>
                </div>


            </div>
        </p-accordionTab>
        <p-accordionTab header="Joe Smith">
            <ng-template pTemplate="header">
                <span class="btn-complete-wrapper">
                    <button class="btn-complete" (click)="completeSheetToggle($event)">
                        Complete
                    </button>
                </span>
            </ng-template>
            <p>
                Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim
                ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Consectetur, adipisci velit, sed quia non numquam eius modi.
            </p>
        </p-accordionTab>
        <p-accordionTab header="Pravesh Devon" class="state-complete">
            <ng-template pTemplate="header">
                <span class="btn-complete-wrapper">
                    <button class="btn-complete" (click)="completeSheetToggle($event)">
                        Complete
                    </button>
                </span>
            </ng-template>
            <p>
                At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa
                qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus.
            </p>
        </p-accordionTab>
    </p-accordion>

    <!-- //BEGIN: Edit Donor Info modal -->
    <p-dialog [(visible)]="showDialog" 
        [modal]="true" 
        header="Edit Donor Info"
        [maximizable]="true"
        styleClass="p-dialog-static p-dialog-md fadeinright animation-duration-300">

        <!-- <p-messages 
                [(value)]="messages" 
                [enableService]="false" 
                [closable]="false" />
                -->

        <!-- //TODO: replace alert below with the p-messages component -->

        <div role="alert" class="p-messages p-component" aria-atomic="true" aria-live="assertive" data-pc-name="message">
            <div role="alert" class="p-message p-message-info mt-0">
                <div class="p-message-wrapper" data-pc-section="wrapper">

                    <span class="p-message-icon">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="p-icon"><g clip-path="url(#pn_id_2)"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.11101 12.8203C4.26215 13.5895 5.61553 14 7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.61553 13.5895 4.26215 12.8203 3.11101C12.0511 1.95987 10.9579 1.06266 9.67879 0.532846C8.3997 0.00303296 6.99224 -0.13559 5.63437 0.134506C4.2765 0.404603 3.02922 1.07129 2.05026 2.05026C1.07129 3.02922 0.404603 4.2765 0.134506 5.63437C-0.13559 6.99224 0.00303296 8.3997 0.532846 9.67879C1.06266 10.9579 1.95987 12.0511 3.11101 12.8203ZM3.75918 2.14976C4.71846 1.50879 5.84628 1.16667 7 1.16667C8.5471 1.16667 10.0308 1.78125 11.1248 2.87521C12.2188 3.96918 12.8333 5.45291 12.8333 7C12.8333 8.15373 12.4912 9.28154 11.8502 10.2408C11.2093 11.2001 10.2982 11.9478 9.23232 12.3893C8.16642 12.8308 6.99353 12.9463 5.86198 12.7212C4.73042 12.4962 3.69102 11.9406 2.87521 11.1248C2.05941 10.309 1.50384 9.26958 1.27876 8.13803C1.05367 7.00647 1.16919 5.83358 1.61071 4.76768C2.05222 3.70178 2.79989 2.79074 3.75918 2.14976ZM7.00002 4.8611C6.84594 4.85908 6.69873 4.79698 6.58977 4.68801C6.48081 4.57905 6.4187 4.43185 6.41669 4.27776V3.88888C6.41669 3.73417 6.47815 3.58579 6.58754 3.4764C6.69694 3.367 6.84531 3.30554 7.00002 3.30554C7.15473 3.30554 7.3031 3.367 7.4125 3.4764C7.52189 3.58579 7.58335 3.73417 7.58335 3.88888V4.27776C7.58134 4.43185 7.51923 4.57905 7.41027 4.68801C7.30131 4.79698 7.1541 4.85908 7.00002 4.8611ZM7.00002 10.6945C6.84594 10.6925 6.69873 10.6304 6.58977 10.5214C6.48081 10.4124 6.4187 10.2652 6.41669 10.1111V6.22225C6.41669 6.06754 6.47815 5.91917 6.58754 5.80977C6.69694 5.70037 6.84531 5.63892 7.00002 5.63892C7.15473 5.63892 7.3031 5.70037 7.4125 5.80977C7.52189 5.91917 7.58335 6.06754 7.58335 6.22225V10.1111C7.58134 10.2652 7.51923 10.4124 7.41027 10.5214C7.30131 10.6304 7.1541 10.6925 7.00002 10.6945Z" fill="currentColor"></path></g><defs><clipPath id="url(#pn_id_2)"><rect width="14" height="14" fill="white"></rect></clipPath></defs></svg>
                    </span>
                    <span class="p-message-detail" data-pc-section="detail">Additional content fields can be updated in the Donor Card.</span>
                </div>
            </div>
        </div>

        <p-card styleClass="mb-2">
            <div class="formgrid grid">
                <div class="field col-12 sm:col-6 md:col-4">
                    <label class="field-label">
                        Prefix
                    </label>
                    <input type="text" pInputText placeholder="" />
                </div>
                <div class="field col-12 sm:col-6 md:col-4">
                    <label class="field-label">
                        First Name
                    </label>
                    <input type="text" pInputText placeholder="" />
                </div>
                <div class="field col-12 sm:col-6 md:col-4">
                    <label class="field-label">
                        Middle Name
                    </label>
                    <input type="text" pInputText placeholder="" /> 
                </div>
                <div class="field col-12 sm:col-6 md:col-4">
                    <label class="field-label">
                        Last Name
                    </label>
                    <input type="text" pInputText placeholder="" /> 
                </div>
                <div class="field col-12 sm:col-6 md:col-4">
                    <label class="field-label">
                        Suffix
                    </label>
                    <input type="text" pInputText placeholder="" /> 
                </div>
                <div class="field col-12 sm:col-6 md:col-4">
                    <label class="field-label">
                        Informal Name
                    </label>
                    <input type="text" pInputText placeholder="" />
                </div>
            </div>
        </p-card>

        <p-card styleClass="mb-2">
            <div class="formgrid grid">
                <div class="field col-12 sm:col-6 md:col-4">
                    <label class="field-label">
                        Organization
                    </label>
                    <input type="text" pInputText placeholder="" />
                </div>
                <div class="field col-12 sm:col-6 md:col-4">
                    <label class="field-label">
                        Occupation
                    </label>
                    <input type="text" pInputText placeholder="" />
                </div>
                <div class="field col-12 sm:col-6 md:col-4">
                    <label class="field-label">
                        Employer
                    </label>
                    <input type="text" pInputText placeholder="" /> 
                </div>
                <div class="field col-12 sm:col-6 md:col-4">
                    <label class="field-label">
                        Home Phone
                    </label>
                    <input type="text" pInputText placeholder="" /> 
                </div>
                <div class="field col-12 sm:col-6 md:col-4">
                    <label class="field-label">
                        Mobile Phone
                    </label>
                    <input type="text" pInputText placeholder="" /> 
                </div>
                <div class="field col-12 sm:col-6 md:col-4">
                    <label class="field-label">
                        Office Phone
                    </label>
                    <input type="text" pInputText placeholder="" />
                </div>
                <div class="field col-12 sm:col-6 md:col-4">
                    <label class="field-label">
                        Primary Email
                    </label>
                    <input type="text" pInputText placeholder="" />
                </div>
            </div>
        </p-card>

        <p-card styleClass="mb-2">
            <div class="formgrid grid">
                <div class="field col-12 sm:col-6">
                    <label class="field-label">
                        Biography
                    </label>
                    <textarea rows="4" pInputTextarea ></textarea>
                </div>
                <div class="field col-12 sm:col-6 pt-4">
                    <div class="grid mt-1">
                        <div class="col-6 mb-2">
                            <p-checkbox
                                inputId="doNotSolicit"
                                label="Do Not Solicit" />
                        </div>
                        
                        <div class="col-6 mb-2">
                            <p-checkbox
                                inputId="doNotCall"
                                label="Do Not Call" />    
                        </div>
                        
                        <div class="col-6 mb-2">
                            <p-checkbox
                                inputId="doNotEmail"
                                label="Do Not Email" />    
                        </div>
                        
                        <div class="col-6  mb-2">
                            <p-checkbox
                                inputId="doNotMail"
                                label="Do Not Mail" />    
                        </div>
                        
                        <div class="col-6 mb-2">
                            <p-checkbox
                                inputId="isDeceased"
                                label="Is Deceased" />
                        </div>
                    </div>
                </div>
            </div>
        </p-card>

        <ng-template pTemplate="footer">
            <p-button 
                label="Cancel" 
                [text]="true" 
                (onClick)="showDialog = false" />
            <p-button 
                label="Save" 
                (onClick)="showDialog = false" />
        </ng-template>
    </p-dialog>
</div>
